var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "md-chip",
    _vm._g(
      {
        staticClass: "ui-chip",
        class: {
          "md-accent": _vm.secondary,
          "md-primary": _vm.primary,
        },
        attrs: { "md-clickable": _vm.clickable, "md-disabled": _vm.disabled },
      },
      _vm.$listeners
    ),
    [
      _vm._t("default"),
      _vm._v(" "),
      _vm.tooltip ? _c("md-tooltip", [_vm._v(_vm._s(_vm.tooltip))]) : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }